<template>
  <div class="spinner" :class="small ? 'spinner--small' : ''"></div>
</template>

<script setup lang="ts">
defineProps({
  small: Boolean,
});
</script>